import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: '#F82E4B',
            contrastText: '#fff',
        },
        secondary: {
            main: '#cccccc',
            contrastText: '#21212d',
        },
        background: {
            paper: 'var(--ion-color-light)',
            default: '#21212d'
        },
    },
    typography: {
        fontFamily: [
            'Poppins',
        ].join(','),
    },
});
export default theme;
